import { render } from "./ShareHolderAmount.vue?vue&type=template&id=606c53b9&scoped=true"
import script from "./ShareHolderAmount.vue?vue&type=script&lang=js"
export * from "./ShareHolderAmount.vue?vue&type=script&lang=js"

import "./ShareHolderAmount.vue?vue&type=style&index=0&id=606c53b9&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606c53b9"]])

export default __exports__